import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { api } from "@/lib/api";
import { Plus } from "lucide-react";
import { useState } from "react";
import PerfilAcessoEdit from "./perfil-acesso-edit";
import PerfilAcessoList from "./perfil-acesso-list";
import { PerfilAcesso } from "./interfaces/perfil_acesso.interface";

const PerfilAcessoPage = () => {
  const { toast } = useToast();
  const [open, setOpen] = useState(false);
  const [editingPerfil, setEditingPerfil] = useState<PerfilAcesso | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleEdit = (perfil: PerfilAcesso) => {
    setEditingPerfil(perfil);
    setOpen(true);
  };

  const handleDelete = async (id: number) => {
    if (confirm("Deseja realmente excluir este perfil de acesso?")) {
      try {
        await api.delete(`/api/perfil-acesso/${id}`);
        toast({
          title: "Sucesso",
          description: "Perfil de acesso excluído com sucesso!",
        });
        setRefreshTrigger(prev => prev + 1);
      } catch (error: any) {
        console.error("Erro ao excluir perfil:", error);
        toast({
          title: "Erro",
          description: error.message || "Erro ao excluir perfil de acesso",
          variant: "destructive",
        });
      }
    }
  };

  const handleSuccess = () => {
    setRefreshTrigger(prev => prev + 1);
    setOpen(false);
    setEditingPerfil(null);
  };

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-3xl font-bold tracking-tight text-foreground">Perfis de Acesso</h2>
            <p className="text-muted-foreground mt-1">Gerencie os perfis de acesso do sistema</p>
          </div>
          <Button
            className="gap-2"
            onClick={() => {
              setEditingPerfil(null);
              setOpen(true);
            }}
          >
            <Plus className="h-4 w-4" />
            Novo Perfil
          </Button>
        </div>

        <PerfilAcessoList
          onEdit={handleEdit}
          onDelete={handleDelete}
          refreshTrigger={refreshTrigger}
        />

        <PerfilAcessoEdit
          open={open}
          onOpenChange={setOpen}
          perfil={editingPerfil}
          onSuccess={handleSuccess}
        />
      </div>
    </Layout>
  );
};

export default PerfilAcessoPage;

